export const isEqualArraysShallow = <T>(arr1: Array<T>, arr2: Array<T>) => {
    return arr1.every((it, index) => it === arr2[index]);
};
